// import _ from 'underscore'

const notices = {
    novedades: []
}

const datanovedades = {    
    data: {}
}

const mutations = {
    SET_NOVEDADES (state, estado) {
        state.estado = estado
        notices.novedades = estado;
        //console.log('estado', notices);  // eslint-disable-line
        // console.log('state', state);  // eslint-disable-line
    },
    DATA_TO_NOVEDADES (state, data) {
        datanovedades.data = data;        
        // console.log('state', state);  // eslint-disable-line
        //console.log('data', datanovedades);  // eslint-disable-line
    }    
}

const getters = {
    novedades () {        
        //console.log('todo', notices);  // eslint-disable-line
        return notices.novedades;
        // if (!state.ordenes || state.ordenes.length === 0) return []
        // const estados = state.ordenes.map(item => item.estado)
        // return _.unique(estados)
    },
    datafornovedades() {
        return datanovedades.data;
    }
}

export default { getters, mutations, notices }
